export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 1.5a1 1 0 01.997 1.071L18.788 5.5H21a1 1 0 011 1V9a4.5 4.5 0 01-3.99 4.47A6 6 0 0113 17.463V20.5h3v2H8v-2h3v-3.037a6.001 6.001 0 01-5.01-3.993A4.5 4.5 0 012 9V6.5a1 1 0 011-1h2.212l-.21-2.929A1 1 0 016 1.5h12zM7.666 11.785a4 4 0 003.99 3.715h.689a4 4 0 003.989-3.715l.593-8.285H7.073l.593 8.285zM4 9c0 1.074.678 1.987 1.629 2.34L5.354 7.5H4V9zm14.37 2.34A2.498 2.498 0 0020 9V7.5h-1.355l-.275 3.84z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};